
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { createMealModel } from '../../pages/Dashboard/DiningOrders/Model/MealModel';

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

const DinningOrdersOutlet = () => {
    const [meal, setMeal] = useState({ ...createMealModel() });
    
    return (
        <>
            <Outlet context={{
                meal,
                setMeal
            }} />
        </>
    );
};

export default DinningOrdersOutlet;
